import { createRouter, createWebHistory } from 'vue-router';
import store from '../store/index.js';

import home from '../views/Home.vue';
import Members from '../views/Members.vue';
import Member from '../views/MemberDetails.vue';
import Groups from '../views/ConnectionGroups.vue';
import MemberRegistration from '../views/members/MemberRegistration.vue';
import GroupRegistration from '../views/groups/GroupRegistration.vue';
import UserAuth from '../views/auth/UserAuth.vue';
import About from '../views/About.vue';



const router = createRouter({
  history: createWebHistory(),
  routes: [

    { path: '/', component: home },
    { path: '/members', component: Members },
    {
      path: '/members/:id',
      component: Member, props: true
    },
    {
      path: '/register', component: MemberRegistration
    },
    { path: '/groups', component: Groups, meta: { requiresAuth: true } },
    { path: '/registergroup', component: GroupRegistration, meta: { requiresAuth: true } },
    // {
    //   path: '/groups/id',
    //   component: Group
    // },
    { path: '/About', component: About },
    { path: '/auth', component: UserAuth },

    {
      path: '/:notFound(.*)', component: home
    }
  ]
});

router.beforeEach(function (to, _, next) {
  if (to.meta.requresAuth && !store.getters.isAuthenticated) {
    next('/auth');
  } else if (to.meta.requiresUnauth && store.getters.isAuthenticated) {
    next('/coaches');
  } else {
    next();
  }
});


export default router;